import { Controller } from "@hotwired/stimulus"

// "Notify me when the minutes are ready" — opt-in from the generating-minutes
// spinner. Opens a confirm modal, POSTs the opt-in, and swaps the trigger for
// an inline confirmation so the user knows the email is set.
export default class extends Controller {
  static targets = ["modal", "trigger", "done", "doneText", "confirm"]
  static values = { url: String }

  open() { this.modalTarget.classList.remove("hidden") }
  close() { this.modalTarget.classList.add("hidden") }
  stop(e) { e.stopPropagation() }

  async confirm() {
    if (this._busy) return
    this._busy = true
    if (this.hasConfirmTarget) this.confirmTarget.textContent = "Saving…"

    try {
      const resp = await fetch(this.urlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content,
          "Accept": "application/json"
        },
        credentials: "same-origin"
      })
      const data = await resp.json().catch(() => ({}))
      this.close()

      // Swap the trigger button for an inline confirmation.
      if (this.hasTriggerTarget) this.triggerTarget.classList.add("hidden")
      if (this.hasDoneTarget) {
        if (data.status === "already_ready" && this.hasDoneTextTarget) {
          this.doneTextTarget.textContent = "Minutes are ready — refresh the page"
        }
        this.doneTarget.classList.remove("hidden")
      }
    } catch (_e) {
      if (this.hasConfirmTarget) this.confirmTarget.textContent = "Notify me"
    } finally {
      this._busy = false
    }
  }
}
